(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
// Mobile responsive section
(function(){
  // Open/close on tap or click
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.spec-help');
    const all = document.querySelectorAll('.spec-help.is-open');
    // Close others if clicking a new one
    all.forEach(el => { if (el !== btn) el.classList.remove('is-open'); });

    if (btn){
      e.preventDefault();
      btn.classList.toggle('is-open');
    } else {
      // Clicked outside -> close all
      if (!e.target.closest('.specsheet') && !e.target.closest('.spec-table')){
        all.forEach(el => el.classList.remove('is-open'));
      }
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      document.querySelectorAll('.spec-help.is-open').forEach(el => el.classList.remove('is-open'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
